import type { InfoText, Product } from '@virginexperiencedays/products';
import config from '../../../SEO/structured_data.config.json';

export const faqs = ({
  product,
  texts,
  pagePathOverride,
}: {
  product: Product;
  texts: InfoText[];
  pagePathOverride?: string;
}) => {
  const { website } = config;
  const { slug, info: { whatsIncluded = null } = { whatsIncluded: null } } = product;

  const pagePath = pagePathOverride || `/product/${slug}`;
  const pageUrl = `${website.url?.replace(/\/$/, '')}${pagePath}`;

  const mainEntity = texts
    .filter(({ name }) => name && FAQKeys.has(name.toLowerCase()))
    .map(faq)
    .concat([faq({ name: `What's included?`, content: whatsIncluded })])
    .filter((value) => !!value);

  if (!mainEntity?.length) return null;

  return {
    '@type': 'FAQPage',
    '@id': `${pageUrl}#faqs`,
    mainEntity,
  };
};

export const faq = ({ name, content }) =>
  content && {
    '@type': 'Question',
    name,
    acceptedAnswer: {
      '@type': 'Answer',
      text: content,
    },
  };

export const FAQKeys = new Set([
  `what do I receive when i've activated my voucher?`,
  'what happens on the day?',
  'what should i wear?',
  'what about insurance?',
  'how do i use my voucher?',
  'where does the experience take place?',
  'what happens on the day?',
  'what cars are available?',
  'what locations are there?',
  'what about the weather?',
]);

export default faqs;
